import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Fade } from "@mui/material";
import { CompanyBackButton } from "../components/backButton/CompanyBackButton";
import { CompanyPageHeader } from "../components/header/CompanyPageHeader";
import { CompanyBadgesTable } from "../components/table/CompanyBadgesTable";
import { useGetCompanyBadges } from "../components/table/hooks/useGetCompanyBadges";
import { LoadingSpinner } from "../../common";
import { Routes } from "../../../routes";
import { CompanyPageRouteProps } from "../types";
import { useSelectedCompanyData } from "../components/table/hooks/useSelectedCompanyData";
import { useExhibitorDetailsData } from "../components/table/hooks/useExhibitorDetailsData";

const CompanyPage = () => {
  const history = useNavigate();
  const location = useLocation();
  const { defineCompanyData, companyData, leadManagerCode, mshOrganisations } = useGetCompanyBadges({
    selectedCompany: (location.state as CompanyPageRouteProps)?.company
  });
  const participatingOrganisationId =
    companyData?.participatingOrganisationId ?? null;
  const { exhibitorType } = useSelectedCompanyData((location.state as CompanyPageRouteProps)?.company);
  const { shouldShowExhibitorDetails } = useExhibitorDetailsData(participatingOrganisationId, exhibitorType);

  const historyState = location.state as CompanyPageRouteProps;
  useEffect(() => {
    if (!historyState?.company) {
      history(Routes.badges);
      return;
    }
    defineCompanyData(historyState.company);
  }, [location]);

  if (!companyData) {
    return <LoadingSpinner />;
  }

  return (
    <Fade in>
      <div>
        <CompanyBackButton />
        <CompanyPageHeader
          companyData={companyData}
          leadManagerCode={leadManagerCode}
          mshOrganisation={mshOrganisations}
          selectedCompany={(location.state as CompanyPageRouteProps)?.company}
          shouldShowExhibitorDetails={shouldShowExhibitorDetails}
        />
        <CompanyBadgesTable selectedCompany={(location.state as CompanyPageRouteProps)?.company} />
      </div>
    </Fade>
  );
};

export default CompanyPage;
